export const routes = {
  home: '/',
  signin: '/signin',
  signout: '/signout',
  users: '/users',
  matches: '/matches',
  prediction: '/prediction',
  history: '/history'
};
